import React, { useEffect } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useRefCallback } from '@bydesign-ui/hooks';
import { CloseSmall } from '../../../common/icons';
import { Dropdown } from '../../../components/dropdown';
import { useTabBarItem } from '../hooks';
export function TabBarItem(props) {
  var id = props.id,
      index = props.index,
      _props$collapsed = props.collapsed,
      collapsed = _props$collapsed === void 0 ? false : _props$collapsed,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$closable = props.closable,
      closable = _props$closable === void 0 ? true : _props$closable,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$lastIsActive = props.lastIsActive,
      lastIsActive = _props$lastIsActive === void 0 ? false : _props$lastIsActive,
      onClick = props.onClick,
      handleClose = props.handleClose,
      onUnregistered = props.onUnregistered,
      label = props.label;
  var spanElement = null;
  var itemElement = null;

  var _useTabBarItem = useTabBarItem(id, collapsed),
      tabBarRef = _useTabBarItem.tabBarRef;

  var clickHandler = useRefCallback(function () {
    !disabled && onClick(id);
  });
  var closeHandler = useRefCallback(function (e) {
    if (!disabled) {
      e.stopPropagation();
      handleClose(id, e);
    }
  });
  useEffect(function () {
    return function () {
      onUnregistered === null || onUnregistered === void 0 ? void 0 : onUnregistered(id);
    };
  }, []);
  var itemCls = usePrefixCls('tab-bar-item', {
    active: active,
    disabled: disabled
  });
  var itemLabelCls = usePrefixCls('tab-bar-item-label');
  var itemCloseCls = usePrefixCls('tab-bar-item-close');
  var itemSpanCls = usePrefixCls('tab-bar-item-span');

  if (index !== 0 && !active && !lastIsActive && !collapsed) {
    spanElement = React.createElement("span", {
      key: "span-".concat(id),
      className: itemSpanCls
    });
  }

  if (collapsed) {
    itemElement = React.createElement(Dropdown.MenuItem, {
      className: itemCls,
      id: id,
      key: id,
      disabled: disabled
    }, label);
  } else {
    itemElement = React.createElement("div", {
      className: itemCls,
      key: id,
      onClick: clickHandler,
      ref: tabBarRef
    }, React.createElement("span", {
      className: itemLabelCls
    }, label), closable && React.createElement("span", {
      className: itemCloseCls,
      onClick: closeHandler
    }, React.createElement(CloseSmall, null)));
  }

  return React.createElement(React.Fragment, null, spanElement, itemElement);
}